export const TVO_ITEMS = [
  {
    title: 'Operacional',
    itens: [
      {
        label: 'Trades',
        icon: 'description',
        materialIcon: true,
        route: 'pedidos',
        flag: 'OT',
      },
      {
        label: 'Triagem',
        icon: 'collections_bookmark',
        materialIcon: true,
        route: 'triagem/buscar',
        flag: 'OTR',
      },
      {
        label: 'Usuários',
        icon: 'supervisor_account',
        route: 'acessos/usuarios',
        materialIcon: true,
        flag: 'OU',
      },
      {
        label: 'Varejistas',
        icon: 'shopping_cart',
        route: 'varejistas',
        materialIcon: true,
        flag: 'OV',
      },
      {
        label: 'Transportadoras',
        icon: 'local_shipping',
        route: 'transportadoras',
        materialIcon: true,
        flag: 'OTP',
      },
      {
        label: 'Lojas',
        icon: 'storefront',
        route: 'lojas',
        materialIcon: true,
        flag: 'OL',
      },
    ],
  },
  {
    title: 'Relatórios',
    itens: [
      {
        label: 'Relatório de Trades',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/pedidos',
        flag: 'RT',
      },
      {
        label: 'Histórico de Transportes',
        icon: 'local_shipping',
        materialIcon: true,
        route: 'relatorio/transportes',
        flag: 'RHT',
      },
      {
        label: 'Relatório de Pendências',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/pendencias',
        flag: 'RP',
      },
      {
        label: 'Linha do tempo',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/timeline',
        flag: 'RLT',
      },
      {
        label: 'Erros Fora da Trilha',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/dlqs',
        flag: 'RDLQ',
      },
      {
        label: 'Erros',
        icon: 'assignment',
        materialIcon: true,
        route: 'erros',
        flag: 'RE',
      },
    ],
  },
];
